"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoButton = void 0;
/*
 * © 2017 Renishaw plc. All rights reserved.
 * This source file is the confidential property and copyright of Renishaw plc
 * Reproduction or transmission in whole or in part, in any form or
 * by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 */
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("../styled-components"));
const __1 = require("..");
const Icons_1 = require("../Icons");
/** A help icon with a tooltip. No translation is done in this component, so pass in ready-translated strings. */
const InfoButton = ({ title, content }) => {
    const [open, setOpen] = react_1.default.useState(false);
    const infoRef = react_1.default.useRef(null);
    return (react_1.default.createElement(Trigger, { tabIndex: 0, onClick: (evt) => {
            setOpen(true);
            evt.stopPropagation();
        }, onKeyDown: (evt) => {
            if ([" ", "Enter"].includes(evt.key)) {
                setOpen(true);
                evt.stopPropagation();
            }
        }, ref: infoRef },
        react_1.default.createElement(Icons_1.Info, null),
        react_1.default.createElement(__1.Popup, { open: open, onClose: () => setOpen(false), referenceElement: infoRef.current, title: title },
            content,
            react_1.default.createElement(__1.FlexSpace, { size: 20 }))));
};
exports.InfoButton = InfoButton;
const Trigger = styled_components_1.default.div `
  cursor: help;
  grid-row: 1;
  grid-column: 3;
  height: 16px;
  width: 16px;
  margin-top: 4px;
  &:focus {
    outline: 1px solid #fffa;
    outline-offset: 2px;
  }
`;
//# sourceMappingURL=index.js.map